import { render, staticRenderFns } from "./MonthName.vue?vue&type=template&id=65c4cc58&lang=pug&"
import script from "./MonthName.vue?vue&type=script&lang=js&"
export * from "./MonthName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports